import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"

import "./test.vue?vue&type=style&index=0&id=baeb3c42&lang=scss"

const __exports__ = script;

export default __exports__